<template>
  <div class="flex items-center justify-center py-10" v-if="!order">
    <a-spin size="large" class="generation">
      <a-icon slot="indicator" type="loading" style="font-size: 60px; color: orange" spin />
    </a-spin>
  </div>

  <div v-else>
    <wizard-page-header :stepTitle="stepTitle"></wizard-page-header>

    <div>
      <a-tabs v-if="mobile" :activeKey="activeTab" @change="changeTab">
        <a-tab-pane tab="Dettagli" key="1"></a-tab-pane>
        <a-tab-pane tab="Polizze" key="2"></a-tab-pane>
      </a-tabs>

      <a-row>
        <a-col :xs="24" :lg="6" v-if="!mobile || (mobile && activeTab == '1')">
          <div class="flex items-center justify-between px-4 py-2 mx-8 mb-3 rounded bg-i4m-grey">
            <div class="text-lg font-bold">Il tuo ordine</div>
            <div class="font-bold">
              <span class="text-i4m-orange">#</span>
              {{ order.code }}
            </div>
          </div>

          <new-order-sidebar
            v-if="order"
            :hideTitle="true"
            :canEdit="false"
            :order_items="order.order_items"
          >
            <template v-slot:chosenOffer>
              <div
                class="flex flex-col items-center p-2 mb-3 bg-white border-2 rounded border-i4m-orange"
              >
                <div class="mb-4 text-lg font-semibold text-i4m-orange">Offerta selezionata</div>

                <div class="flex items-center w-full">
                  <svgicon
                    :name="`companies/${order.chosen_offer.company.url_logo}`"
                    width="150"
                    height="48"
                    :original="true"
                    class="mx-auto mb-6"
                  ></svgicon>
                </div>

                <company-coverages
                  :coverages="order.chosen_offer.company.coverages"
                  layout="col"
                ></company-coverages>

                <div class="mb-1 text-sm opacity-70" v-if="!priceFrozen && !order.paid_on">
                  A partire da
                </div>
                <div class="flex items-baseline">
                  <euro-value
                    :value="order.chosen_offer.value"
                    class="text-4xl font-bold"
                    smallerDecimals
                    symbolBefore
                    hideDecimalsIfZero
                  />
                  <div class="ml-1 text-sm opacity-75">/ anno</div>
                </div>

                <div v-if="order.paid_on" class="mt-2 text-sm">
                  <div class="flex items-center gap-1">
                    Pagato il {{ new Date(order.paid_on).toLocaleDateString() }} con
                    <scalapay-logo
                      v-if="order.payment_method === 'scalapay'"
                      color="#ed8936"
                    ></scalapay-logo>
                    <div v-else>carta di credito</div>
                  </div>
                </div>
                <div v-else>
                  <scalapay-widget
                    :amount="order.chosen_offer.value"
                    locale="it"
                    currencyPosition="after"
                    logoColor="#ed8936"
                    class="mb-4 text-center"
                  ></scalapay-widget>

                  <div class="mt-2 mb-2 text-xs text-center opacity-70" v-if="!priceFrozen">
                    Il prezzo verrà confermato dopo aver completato la verifica della documentazione
                  </div>
                </div>
              </div>

              <div class="mb-3 bg-white border rounded-md">
                <div class="flex items-center justify-between h-12 px-6 py-4 border-b">
                  <span class="mr-3 opacity-75">Stato:</span>

                  <div class="flex items-center">
                    <span class="font-bold text-right">{{ $t(`status.${order.status}`) }}</span>
                  </div>
                </div>

                <div class="flex items-center justify-between px-6 py-4 border-b">
                  <span class="mr-3 opacity-75">Contraente:</span>
                  <span class="font-bold">
                    {{ order.customer.name + ' ' + order.customer.surname }}
                  </span>
                </div>

                <div class="flex items-center justify-between px-6 py-4 border-b">
                  <span class="mr-3 opacity-75">Scadenza:</span>
                  <span class="font-bold text-right opacity-50">
                    Sarà definita al momento dell'acquisto
                  </span>
                </div>
              </div>

              <div class="flex items-center justify-between px-4 py-2 mb-3 rounded bg-i4m-grey">
                <div class="text-lg font-bold">Strumenti</div>
                <div class="text-lg font-bold">{{ order.order_items.length }}</div>
              </div>
            </template>
          </new-order-sidebar>
        </a-col>
        <!-- right zone -->
        <a-col :xs="24" :lg="18" v-if="!mobile || (mobile && activeTab == '2')" class="px-4">
          <div
            class="relative grid max-w-full grid-cols-1 mx-auto mb-10 bg-white md:grid-cols-2 w-max"
            v-if="order.status === 'approved'"
          >
            <div
              class="hidden p-6 text-white border-2 rounded-tl rounded-bl bg-i4m-orange md:block border-i4m-orange"
            >
              <div
                class="flex items-center justify-center p-4 rounded-full w-max"
                :style="{
                  background: '#EDCFB7'
                }"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="48"
                  height="48"
                  fill="#253DED"
                  class="transform -rotate-45"
                  viewBox="0 0 256 256"
                >
                  <rect width="256" height="256" fill="none"></rect>
                  <rect
                    x="24"
                    y="56"
                    width="208"
                    height="144"
                    rx="8"
                    fill="none"
                    stroke="#ed8936"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="12"
                  ></rect>
                  <line
                    x1="168"
                    y1="168"
                    x2="200"
                    y2="168"
                    fill="none"
                    stroke="#ed8936"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="12"
                  ></line>
                  <line
                    x1="120"
                    y1="168"
                    x2="136"
                    y2="168"
                    fill="none"
                    stroke="#ed8936"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="12"
                  ></line>
                  <line
                    x1="24"
                    y1="96.9"
                    x2="232"
                    y2="96.9"
                    fill="none"
                    stroke="#ed8936"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="12"
                  ></line>
                </svg>
              </div>

              <h2 class="mt-6 mb-4 text-3xl font-bold text-white">
                La tua polizza è quasi pronta!
              </h2>

              <div class="mb-4 font-semibold opacity-90">
                I nostri broker hanno approvato l'ordine.
                <br />
                Procedi con il pagamento per attivare la tua polizza.
              </div>
            </div>

            <div
              class="flex flex-col items-stretch px-8 py-10 border-2 rounded-tr rounded-br border-i4m-gray"
            >
              <div class="flex items-baseline justify-center">
                <euro-value
                  :value="order.chosen_offer.value"
                  class="text-4xl font-bold"
                  smallerDecimals
                  symbolBefore
                  hideDecimalsIfZero
                />
                <div class="ml-1 text-sm opacity-75">/ anno</div>
              </div>

              <scalapay-widget
                :amount="order.chosen_offer.value"
                locale="it"
                currencyPosition="after"
                logoColor="#ed8936"
                class="mx-auto mt-4 text-center md:mt-0"
              ></scalapay-widget>

              <div class="flex flex-col mt-10">
                <button
                  class="w-full h-10 mb-4 font-semibold text-white rounded bg-i4m-orange pressable"
                  @click="openPayModal"
                >
                  Paga ora con carta di credito
                </button>
                <button
                  class="flex items-center justify-center h-10 mb-2 font-semibold text-black rounded pressable"
                  @click="openScalaModal"
                  :style="{
                    backgroundColor: '#F8D0D8'
                  }"
                >
                  Paga in 3 rate con
                  <scalapay-logo></scalapay-logo>
                </button>
              </div>
            </div>
          </div>

          <a-alert
            showIcon
            message="L'ordine non è più modificabile"
            description="L'ordine è stato approvato, per questo non è più possibile effettuare modifiche."
            type="warning"
            v-if="FREEZED_ORDER_STATUSES.includes(order.status)"
            class="mb-4"
          />

          <div
            v-if="order.status != 'active' && order.status != 'approved'"
            class="flex items-center justify-start px-8 py-4 mb-12 rounded-md bg-i4m-orange"
          >
            <svgicon
              original
              name="attachment-upload"
              width="78"
              height="78"
              class="mr-4"
              v-if="!mobile"
            ></svgicon>
            <a-spin
              size="large"
              class="generation"
              v-if="order.status === 'contract_proposal_generation'"
            >
              <a-icon slot="indicator" type="loading" style="font-size: 60px; color: white" spin />
            </a-spin>
            <div
              v-if="order.status === 'contract_proposal_sent'"
              class="font-semibold text-white lg:text-xl"
            >
              Per procedere con la pratica carica i certificati che attestino il valore degli
              strumenti.
            </div>
            <div
              v-if="order.status === 'contract_proposal_generation'"
              class="font-semibold text-white lg:text-xl"
            >
              Generazione documenti in corso...
            </div>
            <div
              v-if="order.status === 'policies_needed'"
              class="font-semibold text-white lg:text-xl"
            >
              <!-- Procedi con la firma digitale delle polizze per completare l'attivazione. -->
              Procedi con la firma delle polizze per completare l'attivazione.
            </div>

            <div
              v-if="order.status === 'approval_neeeded'"
              class="font-semibold text-white lg:text-xl"
            >
              Grazie per aver caricato i documenti richiesti!
              <br />
              L'ordine è in attesa di approvazione da uno dei nostri broker.
              <br />
              Le arriverà notifica via email rispetto all'esito dell'operazione.
            </div>

            <div v-if="order.status === 'approved'" class="font-semibold text-white lg:text-xl">
              L'ordine è stato approvato dai nostri broker. Esegui il pagamento per completare
              l'acquisto e attivare le tue polizze!
            </div>

            <!-- 
            <a-button
              class="flex-shrink-0 ml-8"
              type="primary"
              @click="showAttachmentUploader"
           v-if="!mobile"
            >
              Carica pdf
            </a-button> -->
          </div>

          <file-uploader
            @upload-success="refreshActiveOrder"
            ref="attachmentUploader"
          ></file-uploader>

          <h2 class="mb-8 text-xl lg:mb-8 lg:text-3xl">Polizze ({{ quotations.length }})</h2>

          <div
            v-for="quotation in quotations"
            :key="quotation.id"
            class="mb-6 bg-white border-2 rounded-md border-i4m-grey"
          >
            <div
              class="flex items-center justify-between px-4 py-4 bg-i4m-grey rounded-tr-md rounded-tl-md"
            >
              <div class="text-lg lg:text-xl">Polizza</div>
              <div class="flex items-center">
                <span class="mr-3 opacity-75" v-if="!mobile">Stato:</span>
                <div class="w-4 h-4 mr-2 bg-yellow-400 rounded-full"></div>
                <span class="font-bold">{{ $t(`status.policy${quotation.status}`) }}</span>

                <a-button
                  v-if="!mobile && quotation.status === 'signin'"
                  class="ml-8 btn-small"
                  @click="verifySignatureStatus(quotation.id)"
                  :loading="verifingSignature"
                >
                  Verifica stato firma
                </a-button>

                <a-button
                  v-if="!mobile && quotation.status === 'emitted'"
                  class="ml-8 btn-small"
                  type="primary"
                  @click="openSignatureModal(quotation.id)"
                >
                  Firma digitalmente
                </a-button>
              </div>
            </div>
            <div class="lg:px-6">
              <div v-if="!mobile" class="grid items-center h-12 grid-cols-5 px-4 border-b">
                <div class="opacity-75">Strumento</div>
                <div class="opacity-75">Liutaio/Produttore</div>
                <div class="opacity-75">Modello</div>
                <div class="opacity-75">Valore dichiarato</div>
                <div class="opacity-75">Documenti caricati</div>
              </div>

              <div
                v-for="order_item in quotation.order_items"
                :key="order_item.id"
                class="grid items-center grid-cols-4 px-4 py-3 lg:grid-cols-5"
              >
                <div class="font-bold">{{ order_item.item_name_copy }}</div>
                <div class="font-bold">{{ order_item.luthier }}</div>
                <div class="font-bold">{{ order_item.model }}</div>
                <div class="text-sm font-bold text-right lg:text-left">
                  <euro-value
                    :value="order_item.value"
                    class="text-lg font-bold"
                    smallerDecimals
                    symbolBefore
                    hideDecimalsIfZero
                  />
                </div>
                <div v-if="!mobile">
                  <div
                    v-if="order_item.attachments && order_item.attachments.length > 0"
                    class="flex flex-col"
                  >
                    <div
                      v-for="att in order_item.attachments"
                      :key="att.id"
                      class="flex flex-no-wrap items-center justify-between pb-2 mb-2"
                    >
                      <a
                        @click="openFile(att.id)"
                        class="font-mono text-sm underline cursor-pointer"
                      >
                        {{ att.name }}
                      </a>
                      <a-icon
                        :type="attachmentsDeleting[att.id] ? 'loading' : 'delete'"
                        @click="deleteAttachment(att.id)"
                        class="cursor-pointer"
                        :style="{ fontSize: '16px', color: 'red' }"
                        v-if="
                          !FREEZED_ORDER_STATUSES.includes(order.status) &&
                            (att.type == 'expertise' || att.type == 'certificate')
                        "
                      />
                    </div>
                  </div>
                  <!-- v-if="
                      order_item.attachments.filter(attachment => attachment.type == 'expertise')
                        .lenght == 0
                    " -->
                  <div
                    v-if="
                      order_item.attachments.filter(
                        attachment =>
                          attachment.type == 'expertise' || attachment.type == 'certificate'
                      ).length == 0 && order.status != 'contract_proposal_generation'
                    "
                  >
                    <div
                      class="flex items-center justify-center w-max p-1 rounded-full cursor-pointer bg-i4m-grey-light"
                      @click="showAttachmentUploader(order_item)"
                    >
                      <span class="ml-3 mr-2 font-bold">Carica Certificato</span>
                      <div
                        class="flex items-center justify-center w-8 h-8 mr-2 bg-white rounded-full"
                      >
                        <svgicon color="#ed8936" name="upload" width="16" height="16"></svgicon>
                      </div>
                    </div>
                  </div>
                </div>

                <div v-if="mobile && order_item.attachments" class="col-span-4 mt-6 font-mono">
                  Documenti allegati: {{ order_item.attachments.length }}
                  <div class="my-6">
                    <div
                      v-for="att in order_item.attachments"
                      :key="att.id"
                      class="flex flex-no-wrap items-center justify-between py-2"
                    >
                      <a
                        @click="openFile(att.id)"
                        class="font-mono text-sm underline cursor-pointer"
                      >
                        {{ att.name }}
                      </a>
                      <a-icon
                        :type="attachmentsDeleting[att.id] ? 'loading' : 'delete'"
                        @click="deleteAttachment(att.id)"
                        class="cursor-pointer"
                        :style="{ fontSize: '16px', color: 'red' }"
                        v-if="
                          !FREEZED_ORDER_STATUSES.includes(order.status) &&
                            (att.type == 'expertise' || att.type == 'certificate')
                        "
                      />
                    </div>
                  </div>
                </div>
                <div
                  v-if="
                    mobile &&
                      order_item.attachments.filter(
                        attachment =>
                          attachment.type == 'expertise' || attachment.type == 'certificate'
                      ).length == 0 &&
                      order.status != 'contract_proposal_generation'
                  "
                  class="col-span-4 mt-4"
                >
                  <div
                    class="flex items-center justify-center w-full p-1 rounded-full cursor-pointer bg-i4m-grey-light"
                    @click="showAttachmentUploader(order_item)"
                  >
                    <span class="ml-3 mr-2 font-bold">Carica Certificato</span>
                    <div
                      class="flex items-center justify-center w-8 h-8 mr-2 bg-white rounded-full"
                    >
                      <svgicon color="#ed8936" name="upload" width="16" height="16"></svgicon>
                    </div>
                  </div>
                </div>

                <div
                  v-if="mobile && !order_item.attachments"
                  class="col-span-4 mt-4 font-mono opacity-75"
                >
                  Nessun documento allegato
                </div>
              </div>

              <div class="flex w-full px-4">
                <!--                 <a-button v-if="mobile" class="mt-6 mb-2 btn-small " type="primary">
                  Visualizza dettagli
                </a-button> -->
              </div>

              <!-- load quotation documents -->
              <div
                v-if="
                  quotation.attachments &&
                    quotation.attachments.length > 0 &&
                    order.status != 'contract_proposal_generation'
                "
              >
                <div class="lg:px-6"></div>
                <div v-if="!mobile" class="grid items-center h-12 grid-cols-1 px-4 border-b">
                  <div class="opacity-75">Documenti allegati</div>
                </div>

                <div
                  v-for="attachment in quotation.attachments"
                  :key="attachment.id"
                  class="grid items-center justify-end grid-cols-2 px-4 py-3 md:grid-cols-4"
                >
                  <div class="col-span-1 font-bold md:col-span-3">{{ attachment.name }}</div>
                  <!--                 <div class="font-bold">
                    {{ attachment.description }}
                  </div> -->
                  <div class="flex justify-end col-span-1">
                    <div
                      class="flex items-center justify-center w-max p-1 rounded-full cursor-pointer bg-i4m-grey-light"
                      @click="openFile(attachment.id)"
                    >
                      <span class="ml-3 mr-2 font-bold">Visualizza</span>
                      <div
                        class="flex items-center justify-center w-8 h-8 mr-2 bg-white rounded-full"
                      >
                        <svgicon
                          color="#ed8936"
                          name="attachment-upload"
                          width="16"
                          height="16"
                        ></svgicon>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="lg:px-6"></div>
              </div>
            </div>
          </div>
          <div
            class="mb-6 bg-white border-2 rounded-md border-i4m-grey"
            v-if="order.status != 'contract_proposal_generation'"
          >
            <div
              class="flex items-center justify-between px-4 py-4 bg-i4m-grey rounded-tr-md rounded-tl-md"
            >
              <div class="text-lg lg:text-xl">
                {{ $t('order.documents.title') }} ({{ order.attachments.length }})
              </div>
              <!--               <a-button class="w-48 ml-8 btn-small" type="primary">
                Scarica tutti
              </a-button> -->
            </div>

            <div class="lg:px-6">
              <div
                v-for="attachment in order.attachments"
                :key="attachment.id"
                class="grid items-center justify-between grid-cols-2 px-4 py-3 md:grid-cols-4"
              >
                <div class="col-span-1 font-bold md:col-span-3">{{ attachment.name }}</div>
                <!--                 <div class="font-bold">
                  {{ attachment.description }}
                </div> -->
                <div class="flex justify-end col-span-1">
                  <div
                    class="flex items-center justify-center w-max p-1 rounded-full cursor-pointer bg-i4m-grey-light"
                    @click="openFile(attachment.id)"
                  >
                    <span class="ml-3 mr-2 font-bold">Visualizza</span>
                    <div
                      class="flex items-center justify-center w-8 h-8 mr-2 bg-white rounded-full"
                    >
                      <svgicon
                        color="#ed8936"
                        name="attachment-upload"
                        width="16"
                        height="16"
                      ></svgicon>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </a-col>
      </a-row>
    </div>

    <a-modal
      :visible="payModalOpened"
      :maskClosable="false"
      :destroyOnClose="false"
      :closable="false"
    >
      <h2 class="mb-4 text-2xl">Effettua pagamento</h2>
      <p class="mb-12 leading-normal opacity-75">
        Previo pagamento della polizza e sottoscrizione del contratto tramite firma elettronica OTP,
        il contratto si riterrà perfezionato, e la copertura decorre dalla data effetto, salvo di
        diritto di recesso da esercitare entro 14 giorni
      </p>

      <div class="payment-input" ref="card"></div>

      <div class="flex items-center justify-end w-full" slot="footer">
        <a-button @click="payModalOpened = false">Annulla</a-button>
        <a-button :loading="paying" type="primary" @click="purchase">Effettua pagamento</a-button>
      </div>
    </a-modal>

    <a-modal
      :visible="signatureModal"
      :maskClosable="false"
      :destroyOnClose="false"
      :closable="false"
    >
      <h2 class="mb-10 text-2xl">Con quale modalità preferisci effettuare la firma digitale?</h2>

      <div class="flex flex-col">
        <div
          :style="{ borderColor: signatureMode === 'sms' ? '#253DED' : '' }"
          @click="selectSignatureMode('sms')"
          class="flex items-center p-4 mb-4 border-2 rounded-md cursor-pointer border-i4m-grey"
        >
          <a-icon
            theme="twoTone"
            twoToneColor="#ed8936"
            :style="{ fontSize: '2rem' }"
            type="mobile"
            class="mr-6"
          />
          <span class="flex-grow">Via sms al numero {{ order.customer.phone }}</span>
          <a-icon
            v-if="signatureMode === 'sms'"
            type="check-circle"
            theme="twoTone"
            twoToneColor="#52c41a"
            :style="{ fontSize: '1.5rem' }"
          />
        </div>

        <div
          :style="{ borderColor: signatureMode === 'email' ? '#253DED' : '' }"
          @click="selectSignatureMode('email')"
          class="flex items-center p-4 border-2 rounded-md cursor-pointer border-i4m-grey"
        >
          <a-icon
            theme="twoTone"
            twoToneColor="#ed8936"
            :style="{ fontSize: '2rem' }"
            type="mail"
            class="mr-6"
          />
          <span class="flex-grow">Via email all'indirizzo {{ order.customer.email }}</span>
          <a-icon
            v-if="signatureMode === 'email'"
            type="check-circle"
            theme="twoTone"
            twoToneColor="#52c41a"
            :style="{ fontSize: '1.5rem' }"
          />
        </div>
      </div>

      <div class="flex items-center justify-end w-full" slot="footer">
        <a-button @click="closeSignatureModal">Annulla</a-button>
        <a-button :loading="signing" type="primary" @click="sign">
          Avvia procedura di firma
        </a-button>
      </div>
    </a-modal>
  </div>
</template>

<script>
import FileUploader from '@/components/FileUploader.vue';
import api from '@/api';
import Vue from 'vue';
import utils from '@/utils';
const Stripe = window.Stripe;

// let stripe = Stripe(`pk_test_To0NoYcjdFF5g4UUkvkvBLXO`),
let stripe = Stripe(process.env.VUE_APP_STRIPE_PK),
  elements = stripe.elements();

export default {
  name: 'OrderDetail',
  components: {
    FileUploader
  },

  data() {
    return {
      stepTitle: 'Il tuo ordine',
      attachmentsDeleting: {},
      activeTab: '2',
      FREEZED_ORDER_STATUSES: utils.FREEZED_ORDER_STATUSES,
      payModalOpened: false,
      paying: false,
      signing: false,
      signatureModal: false,
      signatureMode: null,
      signinQuotation: null,
      tabBlurredOn: null, // timestamp of when tab lost focus
      verifingSignature: false,
      refreshTimeout: null,
      scalapayPopup: null
    };
  },

  created() {
    if (!this.$store.state.activeOrder) {
      // try to set auth order if exist
      if (this.$store.state.order && this.$store.state.order.ui_step === 6) {
        this.$store.commit('setActiveOrder', this.$store.state.order);
      } else if (this.$store.state.authOrder) {
        this.$store.commit('setActiveOrder', this.$store.state.authOrder);
      } else {
        // redirect away
        this.$router.replace('/');
      }
    }

    document.addEventListener('visibilitychange', this.handleTabFocus);
  },

  beforeDestroy() {
    document.removeEventListener('visibilitychange', this.handleTabFocus);
    if (this.refreshTimeout) window.clearInterval(this.refreshTimeout);
  },

  watch: {
    // order(val, old) {
    order(val) {
      // console.log('OLD', old);
      if (!val) return;
      if (val.status == 'contract_proposal_generation' && !this.refreshTimeout) {
        this.refreshTimeout = setTimeout(() => {
          this.refreshActiveOrder();
          this.refreshTimeout = null;
        }, 5 * 1000);
      }

      if (val.status != 'contract_proposal_generation' && this.refreshTimeout) {
        window.clearInterval(this.refreshTimeout);
        this.refreshTimeout = null;
      }
    }
  },

  computed: {
    priceFrozen() {
      return this.order.status === 'approved';
    },

    order() {
      return this.$store.state.activeOrder;
    },
    quotations() {
      return this.$store.state.activeOrder.chosen_offer.quotations;
    },
    mobile: function() {
      return this.$mq.resize && this.$mq.below('1023px');
    }
  },

  methods: {
    handleTabFocus() {
      if (document.visibilityState === 'hidden') {
        this.tabBlurredOn = Date.now();
      } else if (document.visibilityState === 'visible') {
        this.refreshOrderIfOld();
        this.tabBlurredOn = null;
      }
    },

    async refreshOrderIfOld() {
      // if user was on another tab or application for more than 2 minutes
      // refresh the order data (if order is not completed)
      if (this.order.status === 'active' || !this.tabBlurredOn) return;

      // if (Date.now() - this.tabBlurredOn > 120000) {
      if (Date.now() - this.tabBlurredOn > 10000) {
        this.refreshActiveOrder();
      }
    },

    async refreshActiveOrder() {
      var o;
      if (
        this.$store.state.order &&
        this.$store.state.activeOrder.id === this.$store.state.order.id
      ) {
        o = await this.$store.dispatch('getOrder', true);
      } else {
        o = await this.$store.dispatch('getAuthOrder', true);
      }

      this.$store.commit('setActiveOrder', o);
    },

    initStripe() {
      // stripe is already initialized
      if (this.card) return;
      this.card = elements.create('card', {
        hidePostalCode: true,
        style: {
          base: {
            fontSize: '18px'
          }
        }
      });
      this.card.mount(this.$refs.card);
      this.card.on('change', e => console.log('event payment:', e));
    },

    openSignatureModal(id) {
      this.signatureModal = true;
      this.signinQuotation = id;
    },

    selectSignatureMode(method) {
      this.signatureMode = method;
    },

    async handleScalapayPopupMsg(e) {
      if (e.type === 'message') {
        let data;

        try {
          data = JSON.parse(e.data);
        } catch (err) {
          console.error('error handleScalapayPopupMsg', err);
        }

        if (data && data.type === 'scalapay-result') {
          await this.refreshActiveOrder();

          this.scalapayPopup?.close();
          this.scalapayPopup = null;
          window.removeEventListener('message', this.handleScalapayPopupMsg);
        }
      }
    },

    openScalaModal() {
      const w = 900;
      const h = 900;
      const l = screen.width / 2 - w / 2;
      const t = screen.height / 2 - h / 2;

      this.scalapayPopup = window.open(
        `${process.env.VUE_APP_URL}/scalapay-result?status=INIT&order_code=${this.order.code}`,
        'connectWindow',
        `width=${w},height=${h},top=${t}, left=${l}, toolbar=no,location=nodirectories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no`
      );

      window.addEventListener('message', this.handleScalapayPopupMsg, false);
    },

    openPayModal() {
      this.payModalOpened = true;
      Vue.nextTick(() => {
        this.initStripe();
      });
    },

    async verifySignatureStatus(id) {
      this.verifingSignature = true;
      try {
        await api.verifySignatureStatus({
          quotation_id: id
        });
      } catch (e) {
        console.error('error verifySignatureStatus', e);
        this.$notification.error({
          message: "C'è stato un errore nella verifica. Riprova o contatta il supporto!",
          duration: 5
        });
        this.verifingSignature = false;
        return;
      }

      await this.refreshActiveOrder();

      this.$notification.success({
        message: 'Polizza firmata con successo!',
        duration: 5
      });

      this.verifingSignature = false;
    },

    closeSignatureModal() {
      this.signatureModal = null;
      this.signinQuotation = null;
      this.signatureMode = null;
    },

    async sign() {
      this.signing = true;

      try {
        await api.signQuotation({
          quotation_id: this.signinQuotation,
          mode: this.signatureMode
        });
      } catch (e) {
        console.error('error signing', e);
        this.$notification.error({
          message: "C'è stato un errore nella procedura. Riprova o contatta il supporto!",
          duration: 5
        });
        this.signing = false;
        return;
      }

      await this.refreshActiveOrder();
      this.signing = false;

      this.$notification.success({
        message: 'Procedura di firma avviata con successo! Controlla il tuo telefono per procedere',
        duration: 5
      });
      this.closeSignatureModal();
    },

    async purchase() {
      this.paying = true;
      const result = await stripe.handleCardPayment(
        this.order.payment_intent_client_secret,
        this.card,
        {
          payment_method_data: {}
        }
      );

      // let paymentIntent = result.paymentIntent;
      this.paying = false;

      if (result.error) {
        this.$notification.error({
          message: "C'è stato un errore nel pagamento. Riprova!",
          duration: 5
        });

        return;
      }

      await this.refreshActiveOrder();
      this.payModalOpened = false;

      this.$notification.success({
        message: 'Pagamento effettuato con successo!',
        duration: 5
      });
    },

    changeTab(tabIndex) {
      this.activeTab = tabIndex;
    },

    async deleteAttachment(id) {
      if (this.attachmentsDeleting[id]) return;

      Vue.set(this.attachmentsDeleting, id, true);
      await api.deleteAttachment(id);

      await this.refreshActiveOrder();

      Vue.set(this.attachmentsDeleting, id, false);
    },

    openFile(id) {
      if (process.env.NODE_ENV === 'production') {
        window.open(`/api/attachments/${id}/open`, '_blank');
      } else {
        window.open(`http://localhost:8080/api/attachments/${id}/open`, '_blank');
      }
    },

    showAttachmentUploader(orderItem) {
      if (this.FREEZED_ORDER_STATUSES.includes(this.order.status)) {
        window.alert(
          'Non puoi modificare questo ordine. Se vuoi effettuare modifiche, contatta il supporto.'
        );
        return false;
      }

      this.$refs.attachmentUploader.open(
        this.order.id,
        'order_item',
        orderItem.id,
        'Allega perizia a ' + orderItem.item_name_copy
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.payment-input {
  padding: 10px;
  border: 2px solid #cfcfcf;
  border-radius: 4px;
}
.generation {
  text-align: center;
  padding: 0px 18px;
  margin: 20px 0;
  color: white;
}
.ant-statistic-content {
  font-size: 1rem;
}

.card-logo-container {
  position: absolute;
  top: -20%;
  left: 50%;
  transform: translateX(-50%);
}
</style>
